import { Box, Button, Grid, IconButton, Toolbar, useMediaQuery, useTheme, Tooltip, Typography, CircularProgress, Popover, MenuItem } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import logo from '../../src/assets/img/ayudantias.svg';
import { themePalette } from "../config/theme.config";
import { BiSolidUserRectangle } from "react-icons/bi";
import { FaUserCircle } from "react-icons/fa";
import { useAppSelector } from "../redux/hooks";
import { LuLogOut } from "react-icons/lu";
import { IoMdMenu } from "react-icons/io";
import { useState, useEffect } from "react";
//import { useCas } from "../cas/CasProvider";
import { FaHome } from "react-icons/fa";
import { PiStudentFill } from "react-icons/pi";
import { GiArchiveResearch } from "react-icons/gi";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { outUser } from "../redux/slices/auth.slice";
import { useDispatch } from "react-redux";
import { PantallaCargaPage } from "../pages/Modulos/PantallaCargaPage";
import { SesionExpiraPage } from "../pages/Modulos/sesionExpiraPage";
//import { useMockIsAuthenticated, useSetAuthenticated } from "../pages/Home/AuthContext";
import { TbReportAnalytics } from "react-icons/tb";
import { GrUserManager } from "react-icons/gr";

const iconos = [
    { id: 1, icon: <FaHome />, texto: "INICIO", enlace: "/" },
    // { id: 2, icon: <PiStudentFill />, texto: "SOLICITUDES", enlace: "/ayudantias" },
    { id: 2, icon: <GiArchiveResearch />, texto: "PROYECTOS", enlace: "/Proyectos" },
    { id: 3, icon: <PiStudentFill />, texto: "AYUDANTÍAS", enlace: "" },
    //{ id: 4, icon: <TbReportAnalytics />, texto: "REPORTES", enlace: "/Reportes" },
    //{ id: 5, icon: <GrUserManager  />, texto: "AYUDANTÍAS", enlace: "/AyudAcad" }
];



export const HeaderBar: React.FC<{}> = () => {
    const { userData } = useAppSelector((state) => state.authReducer);

    const dispatch = useDispatch();
    const[ready, setReady] = useState(false);

    const[esvicerrector, setEsVicerrector] = useState(false);


    const {instance} = useMsal();

    //const setAuthenticated = useSetAuthenticated();

    const handleLogout = () => {
        //setAuthenticated(false);
        //localStorage.removeItem('isAuthenticated');
        dispatch(outUser());
        //window.location.href = "/";
        instance.logoutRedirect();
        
    } 

    const verificarVicerrector = () => {
        if(userData.unidadesVicerrector!=null){
            setEsVicerrector(userData.unidadesVicerrector.tipoPersona ==='V')
        }
        
    } 

    const isAuthenticated = useIsAuthenticated();
    //const isAuthenticated = useMockIsAuthenticated();

    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(true);

    const [selectedIcon, setSelectedIcon] = useState<number | null>(null);

    const width = "75px";
    const size = 30;

    const [selectedSubOption, setSelectedSubOption] = useState<string | null>(null);

    useEffect(() => {
        const currentPath = location.pathname;
        const matchingIcon = iconos.find((icon) => icon.enlace === currentPath);
        verificarVicerrector();
        
        if (matchingIcon) {
            setSelectedIcon(matchingIcon.id);
        }

        if(currentPath == "/Solicitudes/AyudantiasDelegado" || currentPath== "/Solicitudes/AyudantiasDirectivo" || currentPath== "/Solicitudes/AyudantiasVicerrector" || currentPath== "/Solicitudes/Historial"){
            setSelectedIcon(3);
            if(currentPath == "/Solicitudes/AyudantiasDelegado"){
                setSelectedSubOption("Solicitudes de ayudantías (Delegado)");
            }else if(currentPath == "/Solicitudes/AyudantiasDirectivo"){
                setSelectedSubOption("Solicitudes de ayudantías (Directivo)");
            }
            else if(currentPath == "/Solicitudes/AyudantiasVicerrector"){
                setSelectedSubOption("Solicitudes de ayudantías (Vicerrector)");
            }
            else {
                setSelectedSubOption("Historial");
            }
        }

        if(userData && Object.keys(userData).length > 0){
            setReady(true);
        }

    }, [location.pathname, userData]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const goToNavigation = (site: string) => {
        navigate(site);
    };

    const GoTo = (site: string, id: number) => {
        setSelectedSubOption(null);
        setSelectedIcon(id);
        navigate(site);
    };

    const GoToForSubmenu = (site: string,  optionId: string) => {
        setSelectedSubOption(optionId);
        handleClose();
        navigate(site);
    };



    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setSelectedIcon(parseInt(event.currentTarget.id));
       
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    
    var existeDirectivo = userData.unidadesDirectivo!=null;
    var validacionDirectivo = existeDirectivo && userData.unidadesDirectivo.tipoPersona=="S" && userData.unidadesDirectivo.unidades.find(x=>x == 15267);


    return (
        ready ?
        <Box sx={{ display: 'flex' }}>
            <Toolbar
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    zIndex: 1200,
                    backgroundColor: themePalette.NAVCOLOR,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Grid container sx={{display:"flex", flexDirection:"row", alignItems:"center"}}>
                    { isAuthenticated && (
                        <Grid item >
                            <IconButton
                                sx={{
                                width: { xs: 21, sm: 35, md: 40 },   // 👈 ancho responsive
                                height: { xs: 21, sm: 35, md: 40 },  // 👈 alto responsive
                                color: '#808080',
                                backgroundColor: isMenuOpen ? '#e0e0e0' : '#f5f5f5',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                transition: 'background-color 0.3s ease, transform 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#d6d6d6',
                                    transform: 'scale(1.05)',
                                },
                                borderRadius: '50%',
                                padding: 0, // 👈 para que el botón no sea más grande por el padding
                                }}
                                onClick={toggleMenu}
                            >
                                <IoMdMenu
                                style={{
                                    fontSize: '1.2rem', // base para xs
                                }}
                                className="menu-icon"
                                />
                            </IconButton>
                        </Grid>
                    )}

                    <Grid item sx={{marginLeft:"30px", padding:"2%"}}>
                        <Box
                            component="img"
                            src={logo}
                            alt="Logo"
                            onClick={() => goToNavigation("/inicio")}
                            sx={{
                                width: { xs: 100, sm: 140, md: 200 }, // 👈 ancho responsivo
                                height: 'auto', // 👈 mantener proporción automáticamente
                                cursor: 'pointer',
                            }}
                            />
                    </Grid>
                </Grid>
                <Grid container item justifyContent="flex-end" alignItems="center" spacing={1}>
                    <Grid item>
                        {isAuthenticated ? (
                        <Box
                            sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#EAEBF0",
                            color: themePalette.NAVCOLOR,
                            paddingX: { xs: 1, sm: 2 }, // 👈 Padding horizontal responsive
                            paddingY: { xs: 0.5, sm: 1 }, // 👈 Padding vertical responsive
                            borderRadius: "16px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.9rem" }, // 👈 Fuente responsive
                            "&:hover": {
                                backgroundColor: themePalette.BG_SIDEBAR,
                                color: "white",
                            },
                            }}
                            onClick={() => console.log("Profile clicked")}
                        >
                            <Box
                            component={BiSolidUserRectangle}
                            sx={{
                                fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' }, // 👈 Tamaño del ícono responsive
                                marginRight: { xs: "4px", sm: "6px" }, // 👈 Separación responsive
                            }}
                            />
                            {userData.username ? (
                            <Typography
                                variant="body2"
                                sx={{
                                fontWeight: "bold",
                                display: { xs: 'block', sm: 'block' }, // 👈 ocultar el username en XS para no saturar
                                }}
                            >
                                {userData.username}
                            </Typography>
                            ) : (
                            <CircularProgress size={16} /> // 👈 tamaño más pequeño del loader
                            )}
                        </Box>
                        ) : (
                        <></>
                        )}
                    </Grid>

                    <Grid item>
                        {isAuthenticated ? (
                        <IconButton
                            aria-label="logout"
                            onClick={handleLogout}
                            sx={{
                            width: { xs: 36, sm: 40, md: 48 }, // 👈 tamaño de botón responsive
                            height: { xs: 36, sm: 40, md: 48 },
                            '& svg': {
                                fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' }, // 👈 ícono logout tamaño responsive
                                color: '#fff',
                                transition: 'color 0.3s ease',
                            },
                            '&:hover svg': {
                                color: '#ccc',
                            },
                            }}
                        >
                            <LuLogOut />
                        </IconButton>
                        ) : (
                        <></>
                        )}
                    </Grid>
                </Grid>
            </Toolbar>

            {isAuthenticated && (
                <Box
                    sx={{
                        position: "fixed",
                        //top: '64px',
                        left: isMenuOpen ? 0 : `-${width}`,
                        width: width,
                        height: '100vh',
                        backgroundColor: themePalette.BG_SIDEBAR,
                        boxShadow: "2px 0px 5px rgba(0, 0, 0, 0.1)",
                        zIndex: 1101,
                        transition: "left 0.5s ease",
                    }}
                >
                    <Box sx={{ width: "100%", paddingTop: "80px", position:"relative" }}>
                        <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                            <Grid item key={iconos[0].id}>
                                <IconButton
                                    onClick={() => GoTo(iconos[0].enlace, iconos[0].id)}
                                    sx={{
                                        backgroundColor: selectedIcon === iconos[0].id ? '#243165' : 'transparent',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        flexDirection: 'column',
                                        mt: 2,
                                        '& svg': {
                                            color: selectedIcon === iconos[0].id ? '#fff' : '#000', // Cambiar color del ícono
                                            transition: 'color 0.3s ease',
                                        },
                                        '&:hover': {
                                            backgroundColor: '#b2ebf2',
                                        },
                                    }}
                                >
                                    {iconos[0].icon}
                                    <Box
                                        sx={{
                                            mt: 1,
                                            textAlign: 'center',
                                            color: selectedIcon === iconos[0].id ? '#fff' : '#000', // Cambiar color del texto
                                            fontSize: '0.55rem',
                                        }}
                                    >
                                        {iconos[0].texto}
                                    </Box>
                                </IconButton>
                            </Grid>

                            {
                                userData.rolesInvestigacion !=null ?

                                userData.rolesInvestigacion.find(x=>x.idrol == 148) ? 
                                <Grid item key={iconos[1].id}>
                                    <IconButton
                                        onClick={() => GoTo(iconos[1].enlace, iconos[1].id)}
                                        sx={{
                                            backgroundColor: selectedIcon === iconos[1].id ? '#243165' : 'transparent',
                                            borderRadius: '8px',
                                            padding: '8px',
                                            flexDirection: 'column',
                                            mt: 2,
                                            '& svg': {
                                                color: selectedIcon === iconos[1].id ? '#fff' : '#000', // Cambiar color del ícono
                                                transition: 'color 0.3s ease',
                                            },
                                            '&:hover': {
                                                backgroundColor: '#b2ebf2',
                                            },
                                        }}
                                    >
                                        {iconos[1].icon}
                                        <Box
                                            sx={{
                                                mt: 1,
                                                textAlign: 'center',
                                                color: selectedIcon === iconos[1].id ? '#fff' : '#000', // Cambiar color del texto
                                                fontSize: '0.55rem',
                                            }}
                                        >
                                            {iconos[1].texto}
                                        </Box>
                                    </IconButton>
                                </Grid>
                                :
                                <></>
                                :
                                <></>
                            } 

                            {

                                userData.unidadesVicerrector!= null || userData.unidadesDirectivo!=null ?

                                (validacionDirectivo || esvicerrector ) ?
                                <Grid item key={iconos[2].id}>
                                <IconButton id={iconos[2].id.toString()}
                                    onClick={handleClick}
                                    sx={{
                                        backgroundColor: selectedIcon === iconos[2].id ? '#243165' : 'transparent',
                                        borderRadius: '8px',
                                        padding: '8px',
                                        flexDirection: 'column',
                                        mt: 2,
                                        '& svg': {
                                            color: selectedIcon === iconos[2].id ? '#fff' : '#000', // Cambiar color del ícono
                                            transition: 'color 0.3s ease',
                                        },
                                        '&:hover': {
                                            backgroundColor: '#b2ebf2',
                                        },
                                    }}
                                >
                                    {iconos[2].icon}
                                    <Box
                                        sx={{
                                            mt: 1,
                                            textAlign: 'center',
                                            color: selectedIcon === iconos[2].id ? '#fff' : '#000', // Cambiar color del texto
                                            fontSize: '0.55rem',
                                        }}
                                    >
                                        {iconos[2].texto}
                                    </Box>
                                </IconButton>

                                    <Popover
                                        id={id}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "center",
                                        }}
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "center",
                                        }}
                                    >
                                        {
                                            validacionDirectivo ?
                                            <MenuItem 
                                                sx={{
                                                    backgroundColor: selectedSubOption === "Solicitudes de ayudantías (Delegado)" ? '#243165 !important' : 'transparent',
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        backgroundColor: '#b2ebf2',
                                                    },
                                                    color: selectedSubOption === "Solicitudes de ayudantías (Delegado)" ? '#fff' : '#000',
                                                }} 
                                                selected={selectedSubOption === "Solicitudes de ayudantías (Delegado)"} onClick={() => GoToForSubmenu("/Solicitudes/AyudantiasDelegado","Solicitudes de ayudantías (Delegado)")}>
                                                    Solicitudes de ayudantías (Delegado)
                                            </MenuItem>
                                            :
                                            null
                                        }
                                        
                                        
                                        {
                                            userData.unidadesVicerrector!=null 
                                            ?
                                            userData.unidadesVicerrector.tipoPersona=="V"  ? 

                                            <MenuItem 
                                                sx={{
                                                    backgroundColor: selectedSubOption === "Solicitudes de ayudantías (Vicerrector)" ? '#243165 !important' : 'transparent',
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        backgroundColor: '#b2ebf2',
                                                    },
                                                    color: selectedSubOption === "Solicitudes de ayudantías (Vicerrector)" ? '#fff' : '#000',
                                                }} 
                                                selected={selectedSubOption === "Solicitudes de ayudantías (Vicerrector)"} onClick={() => GoToForSubmenu("/Solicitudes/AyudantiasVicerrector","Solicitudes de ayudantías (Vicerrector)")}>
                                                    Solicitudes de ayudantías (Vicerrector)
                                            </MenuItem>
                                            :
                                            <></>
                                            :
                                            <></>

                                        }
                                        
                                        
                                    </Popover>
                                </Grid>
                                :
                                <></>
                                :
                                <></>
                            }
                            {/* {
                                userData.rolesInvestigacion!= null ?
                                    userData.rolesInvestigacion.find(x=>x.idrol == 142)?
                                    <Grid item key={iconos[3].id}>
                                        <IconButton id={iconos[3].id.toString()}
                                        onClick={() => GoTo(iconos[3].enlace, iconos[3].id)}
                                        sx={{
                                            backgroundColor: selectedIcon === iconos[3].id ? '#243165' : 'transparent',
                                            borderRadius: '8px',
                                            padding: '8px',
                                            flexDirection: 'column',
                                            mt: 2,
                                            '& svg': {
                                                color: selectedIcon === iconos[3].id ? '#fff' : '#000', // Cambiar color del ícono
                                                transition: 'color 0.3s ease',
                                            },
                                            '&:hover': {
                                                backgroundColor: '#b2ebf2',
                                            },
                                        }}
                                        
                                        >

                                            {iconos[3].icon}
                                            <Box
                                                sx={{
                                                    mt: 1,
                                                    textAlign: 'center',
                                                    color: selectedIcon === iconos[3].id ? '#fff' : '#000', // Cambiar color del texto
                                                    fontSize: '0.55rem',
                                                }}
                                            >
                                                {iconos[3].texto}
                                            </Box>

                                        </IconButton>


                                    </Grid>
                                    :
                                    <></>
                                :
                                <></>
                            }

                            {
                                <Grid item key={iconos[4].id}>
                                        <IconButton id={iconos[4].id.toString()}
                                        onClick={() => GoTo(iconos[4].enlace, iconos[4].id)}
                                        sx={{
                                            backgroundColor: selectedIcon === iconos[4].id ? '#243165' : 'transparent',
                                            borderRadius: '8px',
                                            padding: '8px',
                                            flexDirection: 'column',
                                            mt: 2,
                                            '& svg': {
                                                color: selectedIcon === iconos[4].id ? '#fff' : '#000', // Cambiar color del ícono
                                                transition: 'color 0.3s ease',
                                            },
                                            '&:hover': {
                                                backgroundColor: '#b2ebf2',
                                            },
                                        }}
                                        
                                        >

                                            {iconos[4].icon}
                                            <Box
                                                sx={{
                                                    mt: 1,
                                                    textAlign: 'center',
                                                    color: selectedIcon === iconos[4].id ? '#fff' : '#000', // Cambiar color del texto
                                                    fontSize: '0.55rem',
                                                }}
                                            >
                                                {iconos[4].texto}
                                            </Box>

                                        </IconButton>


                                    </Grid>
                            } */}

                        </Grid>
                    </Box>
                </Box>
            )}

            <Box sx={{ padding: '40px' }}></Box>
        </Box>
        :
        <SesionExpiraPage />
    );
};
